<template>
  <div>
    <v-btn
      class="add-item-btn"
      outlined
      block
      large
      depressed
      :loading="buttonLoading"
      :disabled="testator.companyIsTrustee"
      @click.stop="addCompanyAsTrustee"
    >
      <v-icon color="primary">{{ icons.mdiPlusCircle }}</v-icon
      ><span class="trustee-button-text"
        >Add {{ testator.company.trustCompanyName }} as Trustee</span
      >
    </v-btn>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { UPDATE_TESTATOR_MUTATION } from '../../constants/graphql/testators';

  export default {
    name: 'AddCompanyAsTrusteeBtn',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        type: Object,
        required: true,
      },
    },
    methods: {
      addCompanyAsTrustee() {
        this.buttonLoading = true;
        const testatorInputDetails = {
          companyIsTrustee: true,
        };
        const id = this.testator.id;

        this.$apollo
          .mutate({
            mutation: UPDATE_TESTATOR_MUTATION,
            variables: {
              id,
              testatorInputDetails,
            },
          })
          .then(_response => {
            this.buttonLoading = false;
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  .add-item-btn {
    max-width: 90dvw !important;
    display: inline-block;
    .trustee-button-text {
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
